import NewsletterSubscriptionCompletedEvent from "../Events/NewsletterSubscriptionCompletedEvent";
export default class {
    constructor(pubSub, contextsHandler) {
        pubSub.subscribe("newsletterSubscriptionCompleted", (eventName, eventData) => NewsletterSubscriptionCompletedEvent(eventData, contextsHandler));
    }
}
